<script lang="ts" setup>
defineProps<{
  title: string;
  formDirty?: boolean;
  loading?: boolean;
  error?: boolean;
  breadcrumb?: { name: string; url: string }[];
  tabs?: { label: string; to: string }[];
}>();
</script>
<template>
  <div class="flex flex-col h-full bg-gray-50 overflow-x-hidden">
    <ui-header :title="title" :breadcrumb="breadcrumb" :form-dirty="formDirty">
      <template #actions>
        <slot name="header-actions" />
      </template>
    </ui-header>
    <div v-if="loading" class="flex items-center justify-center">
      <div class="flex flex-col items-center justify-center">
        <ui-loader class="mt-[40vh]" />
        <p class="text-gray-500 text-sm mt-3">{{ $t('global.loading') }}</p>
      </div>
    </div>
    <div v-else-if="error && !loading" class="flex items-center justify-center">
      <div class="flex flex-col items-center justify-center">
        <p class="text-gray-500 text-sm mt-3">{{ $t('global.error') }}</p>
      </div>
    </div>
    <div v-else class="flex flex-1 flex-col gap-4 p-4 overflow-x-hidden overflow-y-auto">
      <ui-nav-tabs v-if="tabs" :items="tabs" />
      <div class="relative">
        <transition
          enter-active-class="transition delay-100 ease-out duration-300"
          enter-from-class="transform opacity-0 translate-y-2 absolute w-full"
          enter-to-class="transform opacity-100 translate-y-0 absolute w-full"
          leave-active-class="transition ease-in duration-100"
          leave-from-class="transform opacity-100 translate-y-0 absolute w-full"
          leave-to-class="transform opacity-0 translate-y-2 absolute w-full"
        >
          <nuxt-page v-if="tabs && !$slots.default" />
          <div v-else>
            <slot />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
